export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '40px 24px',
      marginTop: '80px',
      background: 'rgba(0,0,0,0.3)',
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px', marginBottom: '40px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <div style={{
                width: '32px', height: '32px', borderRadius: '8px',
                background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: '800', color: 'white', fontSize: '16px'
              }}>V</div>
              <span style={{ fontWeight: '700', color: '#e2e8f0' }}>VDC Token Tools</span>
            </div>
            <p style={{ color: '#64748b', fontSize: '13px', lineHeight: '1.6' }}>
              No-code token deployment platform on Vistara Diamond Chain.
            </p>
          </div>
          <div>
            <h4 style={{ color: '#e2e8f0', fontWeight: '600', marginBottom: '16px', fontSize: '14px' }}>Quick Links</h4>
            {[
              { label: '🚀 Create Token', href: '/create' },
              { label: '🔍 Explore Tokens', href: '/explore' },
            ].map(link => (
              <a key={link.href} href={link.href} style={{
                display: 'block', color: '#64748b', textDecoration: 'none',
                fontSize: '13px', marginBottom: '10px', transition: 'color 0.2s'
              }}>{link.label}</a>
            ))}
          </div>
          <div>
            <h4 style={{ color: '#e2e8f0', fontWeight: '600', marginBottom: '16px', fontSize: '14px' }}>VDC Ecosystem</h4>
            {[
              { label: '🌐 VDC Explorer', href: 'https://vdscan.io' },
              { label: '💱 VDC DEX Swap', href: '#' },
              { label: '🌉 VDC Bridge', href: '#' },
            ].map(link => (
              <a key={link.label} href={link.href} target="_blank" rel="noreferrer" style={{
                display: 'block', color: '#64748b', textDecoration: 'none',
                fontSize: '13px', marginBottom: '10px'
              }}>{link.label}</a>
            ))}
          </div>
          <div>
            <h4 style={{ color: '#e2e8f0', fontWeight: '600', marginBottom: '16px', fontSize: '14px' }}>Network</h4>
            <div className="glass" style={{ padding: '16px', borderRadius: '12px' }}>
              <div style={{ fontSize: '12px', color: '#64748b', marginBottom: '8px' }}>Chain ID</div>
              <div style={{ fontSize: '14px', color: '#7c3aed', fontWeight: '600' }}>882022</div>
              <div style={{ fontSize: '12px', color: '#64748b', marginTop: '8px', marginBottom: '4px' }}>Symbol</div>
              <div style={{ fontSize: '14px', color: '#06b6d4', fontWeight: '600' }}>VDC</div>
            </div>
          </div>
        </div>
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.06)',
          paddingTop: '24px', textAlign: 'center',
          color: '#374151', fontSize: '13px'
        }}>
          © 2025 VDC Token Tools — Built on Vistara Diamond Chain
        </div>
      </div>
    </footer>
  )
}
